export function getWebDeviceCode(): string {
  const KEY = "tab_device_code";
  let code = sessionStorage.getItem(KEY);
  if (code === null) {
    code = crypto.randomUUID();
    sessionStorage.setItem(KEY, code);
  }
  return code;
}
